import { Provider } from '@angular/core';
import { EVENTO_REPOSITORY } from './repositories/evento.repository';
import { EventoService } from './services/evento.service';

export const EVENTO_PROVIDERS: Provider[] = [
  {
    provide: EVENTO_REPOSITORY,
    useClass: EventoService
  }
];
